export default "__VITE_PUBLIC_ASSET__64ea87c4__"